/** Splash load line. Start stays disabled until `ready`. */
export function setBootStatus(text: string, ready = false): void {
  const status = ensureStatus();
  status.textContent = text;
  const start = document.getElementById('boot-start');
  if (start instanceof HTMLButtonElement) {
    start.disabled = !ready;
    start.setAttribute('aria-disabled', ready ? 'false' : 'true');
  }
  const bar = document.getElementById('boot-bar-fill');
  if (bar) {
    bar.style.width = ready ? '100%' : '42%';
  }
}

function ensureStatus(): HTMLElement {
  const existing = document.getElementById('boot-status');
  if (existing) {
    return existing;
  }
  const splash = document.getElementById('boot-splash') ?? document.body;
  const status = document.createElement('p');
  status.id = 'boot-status';
  status.className = 'boot-status';
  status.textContent = 'Loading Vesper Cay…';
  const bar = document.createElement('div');
  bar.id = 'boot-bar';
  bar.className = 'boot-bar';
  const fill = document.createElement('span');
  fill.id = 'boot-bar-fill';
  bar.append(fill);
  const start = document.getElementById('boot-start');
  if (start) {
    splash.insertBefore(status, start);
    splash.insertBefore(bar, start);
  } else {
    splash.append(status, bar);
  }
  return status;
}
